import { RealTimeSttHearingHeader, RealTimeSttPause, RealTimeSttTranscriptDivider } from '../lib'
import { RealTimeSttSessionMarker } from '../lib/smart/real-time-stt/shared/real-time-stt-session-marker'
import { RealTimeSttRemarkWithMetadata } from './real-time-stt-remark-with-metadata'
import {
  RealTimeSttTranscriptElementBase,
  RealTimeSttTranscriptElementType,
} from './real-time-stt-transcript-element-base'

export interface RealTimeSttMetadata {
  isSealed: boolean
  segmentId: string
}

// Ensure all our transcript elements correctly implement the ElementBase
type EnforceExtends<T extends RealTimeSttTranscriptElementBase & { type: RealTimeSttTranscriptElementType }> = T
export type RealTimeSttTranscriptElement =
  | EnforceExtends<RealTimeSttPause>
  | EnforceExtends<RealTimeSttRemarkWithMetadata>
  | EnforceExtends<RealTimeSttTranscriptDivider>
  | EnforceExtends<RealTimeSttSessionMarker>
  | EnforceExtends<RealTimeSttHearingHeader>

export type RealTimeSttTranscriptElementWithMetadata = RealTimeSttTranscriptElement & RealTimeSttMetadata

export function isSealedContentMarker(element: RealTimeSttTranscriptElement): element is RealTimeSttRemarkWithMetadata {
  return isRemark(element) && !!element.isSealedContentMarker
}

export function isTranscriptDivider(
  element: RealTimeSttTranscriptElement,
): element is RealTimeSttTranscriptDivider & RealTimeSttMetadata {
  return element.type === 'Divider'
}

export function isSessionMarker(
  element: RealTimeSttTranscriptElement,
): element is RealTimeSttSessionMarker & RealTimeSttMetadata {
  return element.type === 'SessionMarker'
}

export function isHearingHeader(
  element: RealTimeSttTranscriptElement,
): element is RealTimeSttHearingHeader & RealTimeSttMetadata {
  return element.type === 'HearingHeader'
}

export function isPause(element: RealTimeSttTranscriptElement): element is RealTimeSttPause & RealTimeSttMetadata {
  return element.type === 'Pause'
}

export function isRemark(element: RealTimeSttTranscriptElement): element is RealTimeSttRemarkWithMetadata {
  return element.type === 'Remark'
}

export const PREVIEW_PANE_REMARK_ID_PREFIX = 'preview-pane-'
